<template>
    <Card :bordered="false" class="border-radius-0">
        <CCard
            :isLoading="isLoading"
            v-model:columns="state.columns"
            v-model:page="state.page"
            :options="state.tableOptions"
            :manages="state.manages"
            :manageExtras="state.manageExtras"
            :rowActions="state.rowActions"
            :clientSide="true"
            :canRefresh="false"
            :visiblePagination="false"
            @search="customSearch"
        >
            <template v-slot:item="{ record }">
                <div class="p-2 d-flex">
                    <router-link :to="{ name: 'lookups-group', params: { group: record.key } }" class="my-auto">
                        <CIcon file="edit.svg" class="mr-2"></CIcon>
                        <span>{{ createGroupTitle({ group: record.key, value: record.value }) }}</span>
                    </router-link>
                    <div class="ml-auto my-auto">
                        <Tooltip v-if="has({ menuContext, key: 'canView' })">
                            <template v-slot:title>{{ $t("button.view") }}</template>
                            <CIcon
                                v-if="has({ menuContext, key: 'canView' })"
                                file="setting.svg"
                                class="text-info mx-1"
                                @click="() => onClickView({ routerPrefix, record, group })"
                            ></CIcon>
                        </Tooltip>
                    </div>
                </div>
            </template>
        </CCard>
    </Card>
</template>

<script>
import { Card, Tooltip } from "ant-design-vue";
import { defineAsyncComponent, defineComponent, reactive } from "vue";
import { state as stateApp } from "../../../../../app.logic";
import { has } from "../../../../../utils/menu-context";
import { createGroupTitle, initState, isLoading, onClickEdit, onClickView, onSearch, routerPrefix } from "./lookup.logic";

export default defineComponent({
    components: {
        Card,
        Tooltip,
        CIcon: defineAsyncComponent(() => import("../../../../../components/icon/CIcon")),
        CCard: defineAsyncComponent(() => import("../../../../../components/card/CCard"))
    },
    props: {
        menuContext: { default: () => stateApp.menuContext }
    },
    setup(props) {
        const group = "ICON";
        const state = reactive(initState({ props, group, forIcon: true }));
        state.searchQuery = "";
        state.page.page = 0;
        state.page.size = 1000000;
        state.page.sort = [{ name: "seq", type: "ASC" }];
        onSearch({ props, state, group, page: state.page });
        const customSearch = ({ page }) => {
            const whereKey = page.where.find(d => (d.name = "key"));
            if (whereKey) {
                const searchQuery = whereKey.value;
                const whereResult = page.data
                    .filter(d =>
                        createGroupTitle({ group: d.key, value: d.value })
                            ?.toLowerCase()
                            .includes(searchQuery?.toLowerCase())
                    )
                    .map((d, index) => ({ logic: index === 0 ? "AND" : "OR", name: "id", operator: "=", value: d.id }));
                if (whereResult.length > 0) {
                    page.where = whereResult;
                } else {
                    page.where = [{ name: "1", operator: "=", value: "0" }]; // not found
                }
            }
        };
        return { props, state, isLoading, onSearch, createGroupTitle, has, customSearch, onClickView, onClickEdit, routerPrefix, group };
    }
});
</script>
